module.exports = __webpack_public_path__ + "img/vehiculomorado.41a38a63.svg";